<template>
    <div id="login-common-comp">
        <!-- banner -->
        <div class="login-left-banner animate__animated animate__fadeIn">
            <el-carousel
                arrow="hover"
                height="550px"
                style="width: 360px; height: 550px"
            >
                <el-carousel-item
                    v-for="item in bannerList"
                    :key="item.id"
                    style="width: 360px; height: 550px"
                >
                    <img
                        :src="item.httpUrl"
                        alt="介绍信息"
                        style="width: 360px; height: 550px; cursor: pointer"
                        @click="loginBgClick(item)"
                    />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="login-common-comp-main animate__animated animate__fadeIn">
            <img class="login-close-icon" src="@/assets/login/login-close-icon.png" alt="" @click="closeLogin" />
            <!-- 微信扫码登录 -->
            <div v-if="loginWay === 1" class="wechat-qr-comp">
                <div class="component-title">微信扫码注册/登录</div>
                <div class="qr-img" @click="refreshQR">
                    <template>
                        <img v-if="imageBase" :src="imageBase" alt="" />
                        <div v-else>
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                    <div v-if="isExpired" class="refresh-icon" @click="refreshQR">
                        <img src="@/assets/login/refresh-icon.png" alt="" />
                    </div>
                </div>
                <div class="qr-txt">微观世界官网</div>
                <div class="line-other">
                    <div class="line"></div>
                    <div class="txt">其他登录方式</div>
                </div>
                <div class="other-login-btn" @click="changeLoginWay(2)">
                    <img src="@/assets/login/login-phone-icon.png" alt="" />
                    <span>账号密码登录</span>
                </div>
                <div class="reg-txt">
                    没有账号？<span class="reg-link" @click="changeLoginWay(3)">立即注册</span>
                </div>
            </div>
            <!-- 账号密码或短信登录 -->
            <div v-if="loginWay === 2" class="account-mes-comp">
                <div class="account-tab-list">
                    <div class="account-tab-li" :class="{ active: loginType === 0 }" @click="changeLoginTab(0)">
                        <span>账号密码登录</span>
                        <div class="account-line"></div>
                    </div>
                    <div class="account-tab-li" :class="{ active: loginType === 1 }" @click="changeLoginTab(1)">
                        <span>短信登录</span>
                        <div class="account-line"></div>
                    </div>
                </div>
                <div v-if="!loginType" class="account-login-form">
                    <div class="account-login-form-item">
                        <el-input v-model.trim="accountLoginInfo.loginName" type="text" placeholder="请输入账号或手机号" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model.trim="accountLoginInfo.password" type="password" placeholder="请输入密码" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model.trim="accountLoginInfo.code" type="text" placeholder="请输入验证码"
                            style="width: 80%" @keyup.enter.native="getAccountLogin" />
                        <button type="el-button" class="get-code-btn" @click="getCaptchaImage">
                            <img v-if="captchaInfo.img" :src="captchaInfo.img" alt="" />
                            <i v-else class="el-icon-loading"></i>
                        </button>
                    </div>
                    <div class="account-login-form-item">
                        <el-checkbox v-model="accountLoginInfo.agree" label="">已阅读并同意微观世界<span class="protocol-link"
                                @click="openProtocol">《用户协议》</span></el-checkbox>
                    </div>
                    <div class="account-login-form-item">
                        <el-button type="el-button" class="login-btn" :loading="loading" @click="getAccountLogin">
                            登录
                        </el-button>
                    </div>
                    <div class="account-login-form-item">
                        <div class="reg-txt" style="text-align: right; margin-top: 0; width: 100%">
                            没有账号？<span class="reg-link" @click="changeLoginWay(3)">立即注册</span>
                        </div>
                    </div>
                    <div class="line-other" style="margin-top: 24px; margin-bottom: 15px">
                        <div class="line"></div>
                        <div class="txt">其他登录方式</div>
                    </div>
                    <div class="chat-login-btn">
                        <img src="@/assets/login/login-wechat-icon.png" alt="" @click="changeLoginWay(1)" />
                    </div>
                </div>
                <div v-else class="account-login-form">
                    <div class="account-login-form-item">
                        <el-input v-model="msgLoginInfo.loginName" type="text" placeholder="请输入手机号" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model="msgLoginInfo.code" type="text" placeholder="请输入验证码" style="width: 80%"
                            @keyup.enter.native="getMsgLogin" />
                        <button type="el-button" class="get-code-btn get-code-btn-msg"
                            :class="{ 'code-btn-disabled': countdown < 60 }" @click="getSendMsg(msgLoginInfo.loginName)"
                            :disabled="countdown < 60">
                            {{ countdown < 60 ? `${countdown}s后重新发送` : '发送验证码' }} </button>
                    </div>
                    <div class="account-login-form-item">
                        <el-checkbox label="" v-model="msgLoginInfo.agree">已阅读并同意微观世界<span class="protocol-link"
                                @click="openProtocol">《用户协议》</span></el-checkbox>
                    </div>
                    <div class="account-login-form-item">
                        <el-button type="el-button" class="login-btn" :loading="loading" @click="getMsgLogin">
                            登录
                        </el-button>
                    </div>
                    <div class="account-login-form-item">
                        <div class="reg-txt" style="text-align: right; margin-top: 0; width: 100%">
                            没有账号？<span class="reg-link" @click="changeLoginWay(3)">立即注册</span>
                        </div>
                    </div>
                    <div class="line-other" style="margin-top: 24px; margin-bottom: 15px">
                        <div class="line"></div>
                        <div class="txt">其他登录方式</div>
                    </div>
                    <div class="chat-login-btn">
                        <img src="@/assets/login/login-wechat-icon.png" alt="" @click="changeLoginWay(1)" />
                    </div>
                </div>
            </div>
            <!-- 注册 -->
            <div v-if="loginWay === 3" class="reg-comp account-mes-comp">
                <div class="reg-comp-top">
                    <div class="reg-comp-top-left">注册账号</div>
                    <div class="reg-comp-top-right" @click="changeLoginWay(2)">返回登录</div>
                </div>
                <div class="account-login-form">
                    <div class="account-login-form-item">
                        <el-input v-model="registerInfo.loginName" type="text" placeholder="请输入手机号" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model="registerInfo.password" type="password" placeholder="请输入密码" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model="registerInfo.rePassword" type="password" placeholder="请输入再次密码" />
                    </div>
                    <div class="account-login-form-item">
                        <el-input v-model="registerInfo.code" type="text" placeholder="请输入验证码" style="width: 80%"
                            @keyup.enter.native="getRegister" />
                        <button type="el-button" class="get-code-btn get-code-btn-msg"
                            :class="{ 'code-btn-disabled': countdown < 60 }" @click="getSendMsg(registerInfo.loginName)"
                            :disabled="countdown < 60">
                            {{ countdown < 60 ? `${countdown}s后重新发送` : '发送验证码' }} </button>
                    </div>
                    <div class="account-login-form-item">
                        <el-checkbox label="" v-model="registerInfo.agree">已阅读并同意微观世界<span class="protocol-link"
                                @click="openProtocol">《用户协议》</span></el-checkbox>
                    </div>
                    <div class="account-login-form-item">
                        <el-button type="el-button" class="login-btn" :loading="loading" @click="getRegister">
                            立即注册
                        </el-button>
                    </div>
                </div>
            </div>
            <!-- 绑定手机号 -->
            <div v-if="loginWay === 4" class="bind-phone account-mes-comp">
                <div class="bind-phone-top">
                    <div class="bind-phone-top-success">
                        <img src="@/assets/login/login-qr-success.png" alt="" />
                        <span>扫码成功</span>
                    </div>
                    <div class="bind-phone-top-txt">
                        为了您的账户安全，防止账号丢失及方便找回请绑定手机号
                    </div>
                </div>
                <div class="account-login-form" style="margin-top: 14px">
                    <el-form :model="bindPhoneInfo" status-icon :rules="rules" ref="ruleForm">
                        <el-form-item label="" prop="phonenumber">
                            <div class="account-login-form-item" style="margin-bottom: 0">
                                <el-input v-model="bindPhoneInfo.phonenumber" type="text" placeholder="请输入手机号"
                                    autocomplete="off" />
                            </div>
                        </el-form-item>
                    </el-form>
                    <!-- <div class="account-login-form-item">
            <el-input
              v-model="bindPhoneInfo.phonenumber"
              type="text"
              placeholder="请输入手机号"
							autocomplete="off"
            />
          </div> -->
                    <div class="account-login-form-item">
                        <el-input v-model="bindPhoneInfo.code" type="text" placeholder="请输入验证码" style="width: 80%"
                            @keyup.enter.native="getPhoneValidate" />
                        <button type="el-button" class="get-code-btn get-code-btn-msg"
                            :class="{ 'code-btn-disabled': countdown < 60 }"
                            @click="getSendMsg(bindPhoneInfo.phonenumber)" :disabled="countdown < 60">
                            {{ countdown < 60 ? `${countdown}s后重新发送` : '发送验证码' }} </button>
                    </div>
                    <div class="account-login-form-item">
                        <el-checkbox label="" v-model="bindPhoneInfo.agree">已阅读并同意微观世界<span class="protocol-link"
                                @click="openProtocol">《用户协议》</span></el-checkbox>
                    </div>
                    <div class="account-login-form-item">
                        <el-button type="el-button" class="login-btn" :loading="loading" @click="getPhoneValidate">
                            立即绑定
                        </el-button>
                    </div>
                    <div class="account-login-form-item">
                        <div class="reg-txt" style="text-align: center; margin-top: 0; width: 100%">
                            没有账号？<span class="reg-link" @click="changeLoginWay(3)">立即注册</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 用户协议 -->
        <protocol v-if="showProtocol" @closeProtocol="closeProtocol" />

        <!-- form提交实现重定向 -->
        <form ref="loginForm" :action="formAction" method="POST">
            <button type="submit" style="display: none;">登录</button>
        </form>
    </div>
</template>

<script>
import {
    getBannerList,
    wechatQrcode,
    captchaImage,
    login,
    getInfo,
    getScanResult,
    phoneValidate,
    phoneRegister,
    phoneLogin,
    sendMsg,
} from '@/api/login' // 引入登录接口
import { setTimeout } from 'core-js'
import protocol from './protocol.vue'
import { getUrlParam } from '@/utils/index'
export default {
    name: 'LoginCommonComp',
    components: {
        protocol,
    },
    props: {
        showLogin: {
            type: Boolean,
            default: false,
        },
    },
    created() { },

    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            }
            if (
                this.bindPhoneInfo.phonenumber !== '' &&
                !this.phoneValid.test(this.bindPhoneInfo.phonenumber)
            ) {
                callback(new Error('仅限中国大陆手机号'))
            } else {
                callback()
            }
        }
        return {
            phoneValid: /^1[3-9]\d{9}$/, // 手机号正则
            // 微信扫码后token登录状态
            token: '',
            // 登录方式 0:账号密码登录 1:短信登录
            loginType: 0,
            // 登录方式 1:微信扫码登录 2:账号密码登录,短信登录 3:注册 4:绑定手机号
            loginWay: 1,
            uuid: '', // 微信二维码接口返回的uuid
            imageBase: '', // 微信二维码图片
            // 图片验证码数据
            captchaInfo: {
                uuid: '', // 图片验证码接口返回的uuid
                img: '', // 图片验证码图片
            },
            loading: false, // 是否正在登录loading
            // 账号密码登录信息
            accountLoginInfo: {
                loginName: '', // 账号或手机号
                password: '', // 密码
                code: '', // 验证码
                agree: false, // 是否同意协议
            },
            // 短信登录信息
            msgLoginInfo: {
                loginName: '', // 手机号
                code: '', // 验证码
                uuid: '', // 短信验证码接口返回的uuid
                agree: false, // 是否同意协议
            },
            countdown: 60, // 倒计时
            isSending: false, // 是否正在发送短信
            timer: null, // 定时器
            // 注册信息
            registerInfo: {
                loginName: '', // 手机号
                password: '', // 密码
                rePassword: '', // 再次密码
                code: '', // 验证码
                uuid: '', // 短信验证码接口返回的uuid
                agree: false, // 是否同意协议
            },
            // 绑定手机号信息
            bindPhoneInfo: {
                uuid: '', // 短信验证码接口返回的uuid 获取短信后回被重新赋值
                token: this.token, // 用户扫码成功后返回的token
                phonenumber: '', // 需要绑定的手机号
                code: '', // 验证码
                agree: false, // 是否同意协议
            },
            // 绑定手机号校验
            rules: {
                phonenumber: [
                    {
                        validator: validatePhone,
                        trigger: 'blur',
                    },
                ],
            },
            pollingTimer: null, // 轮询定时器，用于轮训扫码结果
            expiredTimer: null, // 超时定时器
            isExpired: false, // 超时状态
            showProtocol: false, // 是否显示用户协议
            bannerList: [], // banner图列表
            formAction: '', // 表单提交地址
            redirect: '' // 需要的重定向地址
        }
    },
    mounted() {
        // 获取form表单提交地址
        this.getFormAction()
        // 获取登录框左侧的banner图
        this.getBannerListFn()
        // 获取微信二维码
        this.getWechatQrcode()
    },
    beforeDestroy() {
        this.stopPolling() // 销毁组件时停止轮询
    },
    watch: {
        // 对 loginWay 进行深度监听
        loginWay: {
            // 监听触发的处理函数（替代简写形式的函数）
            handler(newVal, oldVal) {
                // 你的原有业务逻辑：判断 newVal 的 type 属性（根据实际字段调整）
                if (newVal === 1) {
                    this.changeLoginWay(newVal)
                } else {
                    this.stopPolling()
                }
            },
            deep: true, // 关键：开启深度监听，监听对象内部属性变化
            immediate: true, // 可选：是否在组件初始化时立即执行一次 handler（根据需求决定）
        },
    },
    methods: {
        // 映射store中的action到组件方法
        // ...mapActions(["loginAction"]),

        // 获取form表单提交地址
        getFormAction(){
            let origin = process.env.VUE_APP_BASE_WEBSITE_URL
            this.redirect = this.$route.query.redirectUrl
            this.formAction = `${origin}/userservice/auth/wechat/redirect?redirect=${this.redirect}`
            console.log("this.formAction:")
            console.log(this.formAction)
            console.log("this.$refs.loginForm:")
            console.log(this.$refs.loginForm)
        },
        // form表单实现重定向
        formRedirect() {
            if (this.$refs.loginForm && this.redirect) {
                this.$refs.loginForm.submit()  // 触发表单提交
            } else {
                this.$emit('closeLogin')
                const currentRoute = this.$route.path
                // let redirectUrl = this.$route.query.redirectUrl
                this.$router.replace(currentRoute)
                setTimeout(() => {
                    window.location.reload()
                }, 0)
            }
        },

        // 获取banner
        getBannerListFn(){
            getBannerList().then(res=>{
                console.log(res)
                if(res?.data?.data){
                    this.bannerList = res.data.data
                    console.log("this.bannerList")
                    console.log(this.bannerList)
                }
            })
        },
        // banner点击跳转
        loginBgClick(item) {
            window.open(item.jumpTo)
        },
        // 用户协议
        openProtocol() {
            // 产品需求不要打开新页面要用弹窗
            // window.open("https://map.zhibomap.com/user-protocol");
            this.showProtocol = true
        },
        // 关闭用户协议
        closeProtocol() {
            this.showProtocol = false
        },
        // 切换登录方式
        changeLoginWay(type) {
            // 根据切换类型改变登录方式
            this.loginWay = type
            clearInterval(this.pollingTimer)
            switch (type) {
                case 1:
                    // 获取微信二维码
                    // this.getWechatQrcode();
                    this.pollingTimer = setInterval(() => {
                        this.getScanResultFn() // 轮询扫码结果
                    }, 1000)
                    this.setExpiredTimer() // 设置二维码的超时状态
                    break
                case 2:
                    this.getCaptchaImage() // 获取验证码图片
                    this.stopPolling()
                    this.clearExpiredTimer()
                    break
                case 3:
                    this.stopPolling()
                    this.clearExpiredTimer()
                    break
                case 4:
                    this.stopPolling()
                    this.clearExpiredTimer()
                    break
                default:
                    break
            }
        },
        // 2:账号密码登录和短信状态下，切换登录类型（0:账号密码登录 1:短信登录）
        changeLoginTab(i) {
            this.loginType = i // 根据切换类型改变登录类型
        },
        // 关闭登录框
        closeLogin() {
            this.$emit('closeLogin')
            if (this.loginWay === 4) {
                window.location.reload()
            }
        },
        // 获取微信二维码, 只有线上才可以测试
        getWechatQrcode() {
            this.imageBase = '' // 先置空一下防止是旧的的二维码
            let params = {
                code: window.location.origin, // 当前页面地址
                platform: 'PC', // 平台类型 PC
            }
            wechatQrcode(params).then(res => {
                console.log(res)
                let data = res.data.data
                if (data) {
                    this.uuid = data.uuid
                    this.imageBase = data.imageBase
                }
            })
        },
        // 获取验证码图片
        getCaptchaImage() {
            captchaImage().then(res => {
                let data = res.data
                if (res) {
                    this.captchaInfo.uuid = data.uuid // 图片验证码接口返回的uuid
                    this.captchaInfo.img = 'data:image/jpeg;base64,' + data.img // 图片验证码图片
                }
            })
        },
        // 设置超时状态
        setExpiredTimer() {
            this.expiredTimer = setTimeout(
                () => {
                    this.stopPolling()
                    this.clearExpiredTimer()
                    this.isExpired = true // 超时状态设置
                },
                1000 * 60 * 4 // 实际超时时间设置
                // 5000 // 短时间测试
            )
        },
        // 清楚超时状态
        clearExpiredTimer() {
            if (this.expiredTimer) clearTimeout(this.expiredTimer)
            this.expiredTimer = null
            this.isExpired = false // 超时状态设置
        },
        // 刷新微信登录二维码
        refreshQR() {
            this.isExpired = false // 超时状态设置
            this.getWechatQrcode() // 重新获取二维码
            this.changeLoginWay(1) // 重新轮询设置定时器
        },
        // 获取扫码结果状态
        async getScanResultFn() {
            // getScanResult调用扫码结果接口返回的data
            // {
            //   code: 0
            //   msg: "操作成功"
            //   status: 2
            //   token: ''
            // }
            if (!this.uuid) return // 当生成微信二维码借口报错时候，不重复调用接口
            let res = await getScanResult(this.uuid)
            const { token, status } = res.data
            this.token = token // 获取扫码返回的token
            if (status === 0) {
                // status === 0 未扫码
            } else if (status === 1) {
                this.token = token // 获取扫码返回的token
                // status === 1 扫码成功、已绑定手机号
                this.$message.success('登录成功')
                this.getInfoFn(token) // 获取用户信息
                this.stopPolling() // 停止轮询
            } else if (status === 2) {
                this.token = token // 获取扫码返回的token
                // status === 2 扫码成功、未绑定手机号
                this.stopPolling() // 停止轮询
                this.loginWay = 4 // 展示扫码成功后的手机绑定页面
                console.log("status:2 => token:" + this.token) // 获取扫码返回的token
                // this.getInfoFn(token) // 获取用户信息
            }
        },
        // 停止轮询
        stopPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null // 释放引用
            }
        },
        // 判断是否有重定向的页面，如果有需要重定向过去
        getRedirectUrl() {
            let redirectUrl = this.$route.query.redirectUrl
            if (redirectUrl) {
                window.open(redirectUrl)
            }
            return Promise.resolve(true)
        },
        // 获取用户信息
        async getInfoFn(token, type) {
            let res = await getInfo(token)
            let userInfo = res.data.user
            console.log(userInfo)
            this.$store.commit('SET_LOGIN_INFO', {
                token: token,
                userInfo: userInfo,
            })

            // this.loginWay：4 展示扫码成功后的手机绑定页面此时不用刷新页面。
            let typeFlag1 = this.loginWay !== 4 && userInfo
            // 当扫码微信绑定成功后刷新页面type：1为绑定成功，否则扫码登录成功不刷新页面
            let typeFlag2 = type && type === 1 && this.loginWay === 1 && userInfo
            // 手机号绑定成功后刷新页面
            let typeFlag3 = this.loginWay === 4 && userInfo
            if (typeFlag1 || typeFlag2 || typeFlag3) {
                // await this.getRedirectUrl() // 采用form表单实现重定向，则注释this.getRedirectUrl()
                // form表单实现重定向
                this.formRedirect()

                // setTimeout(() => {
                //     this.$emit('closeLogin')
                //     const currentRoute = this.$route.path
                //     // let redirectUrl = this.$route.query.redirectUrl
                //     this.$router.replace(currentRoute)
                //     setTimeout(() => {
                //         window.location.reload()
                //     }, 0)
                // }, 50)
            }
        },
        // 账号密码登录
        getAccountLogin() {
            if (!this.accountLoginInfo.loginName) {
                this.$message.error('请输入账号或手机号！')
                return
            }
            if (!this.accountLoginInfo.password) {
                this.$message.error('请输入密码！')
                return
            }
            if (!this.accountLoginInfo.code) {
                this.$message.error('请输入验证码！')
                return
            }
            if (!this.accountLoginInfo.agree) {
                this.$message.error('请勾选已阅读并同意微观世界《用户协议》！')
                return
            }
            // 调用登录接口所传参数
            let data = {
                loginName: this.accountLoginInfo.loginName, // 账号
                password: this.accountLoginInfo.password, // 密码
                code: this.accountLoginInfo.code, // 验证码
                uuid: this.captchaInfo.uuid, // 验证码uuid
            }
            this.loading = true
            // 调用登录接口
            login(data).then(res => {
                let data = res.data
                if (data && data.token) {
                    let token = data.token // 获取token
                    this.$message.success('登录成功')
                    // 获取用户信息
                    this.getInfoFn(token)
                } else {
                    this.getCaptchaImage() // 重新获取验证码图片
                    this.$message.error(data.msg)
                }
                this.loading = false // 登录loading
            })
        },
        // 发送短信验证码
        async getSendMsg(phone) {
            if (!phone) {
                this.$message.error('请输入手机号！')
                return
            }
            if (!this.phoneValid.test(phone)) {
                this.$message.error('请输入正确手机号!')
                return
            }
            this.startCountdown()

            let data = {
                phone, // 手机号
            }
            let res = await sendMsg(data)
            if (res.data.uuid) {
                switch (this.loginWay) {
                    case 2:
                        this.msgLoginInfo.uuid = res.data.uuid // 短信验证码接口返回的uuid
                        break
                    case 3:
                        this.registerInfo.uuid = res.data.uuid // 短信验证码接口返回的uuid
                        break
                    case 4:
                        this.bindPhoneInfo.uuid = res.data.uuid // 短信验证码接口返回的uuid
                        break
                    default:
                        break
                }
                this.$message.success('验证码已发送，请注意查收')
                // 60s计时器
                this.startCountdown()
            } else {
                this.$message.error(res.data.msg || '发送失败，请重试')
            }
        },
        // 发送短信按钮开始倒计时
        startCountdown() {
            if (this.timer) {
                console.log('清除旧定时器：', this.timer)
                clearInterval(this.timer)
            }
            this.countdown = 60
            this.timer = setInterval(() => {
                console.log('当前定时器ID：', this.timer) // 观察是否重复创建
                this.countdown--
                if (this.countdown <= 0) {
                    clearInterval(this.timer)
                    this.timer = null
                    this.countdown = 60
                }
            }, 1000)
        },
        // 短信验证码登录
        async getMsgLogin() {
            if (!this.msgLoginInfo.loginName) {
                this.$message.error('请输入手机号！')
                return
            }
            if (!this.phoneValid.test(this.msgLoginInfo.loginName)) {
                this.$message.error('请输入正确手机号!')
                return
            }
            if (!this.msgLoginInfo.code) {
                this.$message.error('请输入验证码！')
                return
            }
            if (!this.msgLoginInfo.agree) {
                this.$message.error('请勾选已阅读并同意微观世界《用户协议》！')
                return
            }
            let data = {
                ...this.msgLoginInfo, // 短信登录信息
            }
            this.loading = true // 登录loading
            let res = await phoneLogin(data)
            if (res.data.token) {
                // 调用用户信息
                this.getInfoFn(res.data.token)
                this.$message.success('登录成功')
            } else {
                this.$message.error(res.data.msg || '登录失败，请重试')
            }
            this.loading = false // 登录loading
        },
        // 注册
        async getRegister() {
            if (!this.registerInfo.loginName) {
                this.$message.error('请输入手机号！')
                return
            }
            if (!this.phoneValid.test(this.registerInfo.loginName)) {
                this.$message.error('请输入正确手机号!')
                return
            }
            if (!this.registerInfo.password) {
                this.$message.error('请输入密码！')
                return
            }
            if (!this.registerInfo.rePassword) {
                this.$message.error('请输入再次密码！')
                return
            }
            if (this.registerInfo.password != this.registerInfo.rePassword) {
                this.$message.error('两次密码输入不相同，请重新输入！')
                return
            }
            if (!this.registerInfo.code) {
                this.$message.error('请输入验证码！')
                return
            }
            if (!this.registerInfo.agree) {
                this.$message.error('请勾选已阅读并同意微观世界《用户协议》！')
                return
            }
            this.loading = true
            let res = await phoneRegister({
                ...this.registerInfo,
            })
            if (res.data.code === 500) {
                this.$message.error(res.data.msg || '注册失败！')
            } else {
                this.$message.success('注册成功！')
                // 注册成功后直接获取token，并获取用户信息
                if (res.data.token) {
                    this.getInfoFn(res.data.token)
                }
            }
            this.loading = false
        },
        // 微信扫码成功后，若未绑定手机号，则跳转绑定页面，绑定手机号
        async getPhoneValidate() {
            if (!this.bindPhoneInfo.phonenumber) {
                this.$message.error('请输入手机号！')
                return
            }
            if (!/^[1][3-9][0-9]{9}$/.test(this.bindPhoneInfo.phonenumber)) {
                this.$message.error('请输入正确手机号，仅限中国大陆手机号！')
                return
            }
            if (!this.bindPhoneInfo.code) {
                this.$message.error('请输入验证码！')
                return
            }
            if (!this.bindPhoneInfo.agree) {
                this.$message.error('请勾选已阅读并同意微观世界《用户协议》！')
                return
            }
            this.$refs['ruleForm'].validate(async valid => {
                if (valid) {
                    let data = {
                        ...this.bindPhoneInfo,
                        token: this.token,
                    }
                    this.loading = true
                    let res = await phoneValidate(data)
                    if (res.data.code === 0) {
                        this.$message.success('绑定成功！')
                        let data = res.data // 绑定成功后并没有返回最新token，只有一个code=0的状态码，还是延用扫码返回的token
                        this.getInfoFn(this.token, 1) //  获取用户信息，type：1为绑定成功
                    } else {
                        this.$message.error(res.data.msg || '绑定失败！')
                    }
                    this.loading = false
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
@import '@/assets/less/animate.css';
@import '@/components/Login/css/login.less';
</style>
